import { combineReducers, configureStore } from '@reduxjs/toolkit';
import documentDataReducer from './documentSlice';
import navigationReducer from './navigationSlice';
import prospectDataReducer from './prospectDataSlice';
import territoryManagersReducer from './territoryManagersSlice';
import userdataReducer from './userdataSlice';

const rootReducer = combineReducers({
  userdata: userdataReducer,
  navigationdata: navigationReducer,
  prospectData: prospectDataReducer,
  territoryManagersData: territoryManagersReducer,
  documentData: documentDataReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
  devTools: process.env.NEXT_PUBLIC_ENV !== 'production',
});

export type RootState = ReturnType<typeof rootReducer>;
